export function isPayPayMember({member = {}}) {
    const subscriptions = member.subscriptions || [];
    return subscriptions.some(sub => ['active', 'trialing', 'unpaid', 'past_due'].includes(sub.status) &&
        sub.payment_provider === 'paypay'
    );
}
